import {mapActions, mapGetters, mapMutations} from 'vuex';

import {seo} from '@/mixins/seo'
import {camelCase} from 'lodash'

import Item from './components/course-list-item/index.vue'
import HeadFilter from '@/components/features/head-filter/index.vue'
import BtnLoadMore from '@/components/atoms/buttons/load-more/index.vue'

import ShopPage from '@/modules/shop/index.vue';
import freeAccess from '@/components/features/free-access/index.vue'

import courseLoader from '@/modules/courses/components/course-loader/index.vue'
import coursesLoader from '@/modules/courses/components/courses-loader/index.vue'

import ModalPointA from '@/components/modals/ModalPointA'
import ModalPointB from '@/components/modals/ModalPointB'
import ModalProgress from '@/components/modals/ModalProgress'

export default {
	name		: 'courses',
	mixins		: [seo],
	data() {
		return {
			//isListLoading		: false,
			isLoadMore			: false,
			showPointAModal		: false,
			pointAModalContext	: null,
			showPointBModal		: false,
			pointBModalContext	: null,
			showProgressModal	: false
		}
	},
	components	: {
		Item,
		HeadFilter,
		BtnLoadMore,
		ShopPage,
		'free-access': freeAccess,
		'course-loader': courseLoader,
		'courses-loader': coursesLoader,
		ModalPointA,
		ModalPointB,
		ModalProgress
	},
	computed	: {
		...mapGetters({
			list				: 'courses/coursesList',
			listLength			: 'courses/listLength',
			skip				: 'courses/skip',
			isListLoading		: 'courses/isListLoading',
			isLoadingCategories	: 'courses/isLoadingCategories',
			categories			: 'courses/categories',
			user				: 'user/user'
		}),
	},
	beforeRouteLeave(to, from, next) {
		if (to.name !== `courses-dashboard`) {
			this.changeCategory()
		}
		
		next();
	},
	created() {
		//console.log('courses created:', this.isListLoading);
		
		this.seo.title = this.$t(camelCase(this.$route.name));
		
		this.fetchCategories();
	},
	mounted() {
		//console.log('courses mounted');
	},
	methods		: {
		...mapActions({
			fetchCourses    : 'courses/GET_LIST',
			fetchCategories : 'courses/GET_CATEGORIES',
			fetchCourseItem : 'courses/GET_COURSE_ITEM',
		}),
		...mapMutations({
			changeCategory  : 'courses/CHANGE_CATEGORY',
			setCategories   : 'courses/SET_CATEGORIES',
		}),
		async loadMore(){
			this.isLoadMore = true;
			//this.isListLoading = true;
			
			if(true){
				await this.fetchCourses({
					isResetList: false
				})
			}
			
			this.isLoadMore = false;
		},
		resolvePackageIdFromCoursePayload(course) {
			if (!course || !course.userCourse || !course.userCourse.data) return null
			
			const uc = course.userCourse.data
			
			if (uc.package && uc.package.data && uc.package.data.id != null) {
				return uc.package.data.id
			}
			
			if (uc.packageId != null) return uc.packageId
			
			return null
		},
		resolvePointANextRoute(payload) {
			if (payload.nextRoute && payload.nextRoute.name) {
				return payload.nextRoute
			}
			
			return {
				name	: 'courses-main',
				params	: { item: payload.courseSlug },
			}
		},
		onCourseAbNavigate(payload) {
			if (!payload || !payload.courseSlug) {
				return
			}
			
			this.$router.push(this.$localize(this.resolvePointANextRoute(payload)))
		},
		async onOpenPointBModal(payload) {
			if (!payload || !payload.courseSlug) {
				return
			}
			
			let packageId = payload.packageId
			
			if (packageId == null) {
				try {
					const courseData = await this.fetchCourseItem({
						slug: payload.courseSlug,
					})
					
					packageId = this.resolvePackageIdFromCoursePayload(courseData)
				} catch (e) {
					console.error(e)
				}
			}
			
			if (packageId == null) {
				if (this.$toasted) {
					this.$toasted.error(
						"Не вдалося визначити package_id для A/B форми. Зверніться до підтримки."
					)
				}
				
				return
			}
			
			try {
				await this.$store.dispatch('pointAB/GET_MY_SUBMISSIONS', {
					courseSlug: payload.courseSlug,
				})
			} catch (e) {
				console.error(e)
				
				return
			}
			
			this.pointBModalContext = {
				...payload,
				packageId,
			}
			this.showPointBModal = true
		},
		closePointBModal() {
			this.showPointBModal = false
			this.pointBModalContext = null
		},
		async onOpenPointAModal(payload) {
			if (!payload || !payload.courseSlug) return
			
			if (payload.isPointAFilled) {
				this.$router.push(this.$localize(this.resolvePointANextRoute(payload)))
				
				return
			}
			
			let packageId = payload.packageId
			
			if (packageId == null) {
				try {
					const courseData = await this.fetchCourseItem({
						slug: payload.courseSlug,
					})
					
					packageId = this.resolvePackageIdFromCoursePayload(courseData)
				} catch (e) {
					console.error(e)
				}
			}
			
			if (packageId == null) {
				if (this.$toasted) {
					this.$toasted.error(
						"Не вдалося визначити package_id для A/B форми. Зверніться до підтримки."
					)
				}
				
				return
			}
			
			try {
				await this.$store.dispatch('pointAB/GET_MY_SUBMISSIONS', {
					courseSlug: payload.courseSlug,
				})
			} catch (e) {
				console.error(e)
				
				return
			}
			
			this.pointAModalContext = {
				...payload,
				packageId,
			}
			this.showPointAModal = true
		},
		closePointAModal() {
			this.showPointAModal = false
			this.pointAModalContext = null
		},
		onPointACompleted() {
			this.closePointAModal()
		},
		onPointBCompleted() {
			this.closePointBModal()
			
			// Показуємо модальне вікно з прогресом
			setTimeout(() => {
				this.showProgressModal = true
			}, 500)
		}
	}
}
